import React from "react";
import { Spinner } from "react-bootstrap";

const LoadingDiv = () => {
  return (
    <div className="loading_div">
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
  );
};

export default LoadingDiv;
